import {IWebhook} from './Webhook';
import {IWorkflow} from './Workflow';
import {Folder} from './Folder';
import {ITag} from './Tag';
import {IUser} from './Admin';

export enum REPORT_TYPE {
  REPORT = 'default',
  NOTEBOOK = 'notebook',
  TABLEAU_EMBED = 'tableau_embed',
}

export interface MergeOption {
  position?: number;
  include?: boolean;
  uid?: string;
}

export interface MergeCSVOption extends MergeOption {
  sheet_name?: string;
}

export interface MergeConfig {
  enabled: boolean;
  filename: string;
  options: MergeOption[];
}

export interface MergeCSVConfig extends MergeConfig {
  options: MergeCSVOption[];
}


export interface Report {
  id?: number;
  uid?: string;
  type?: string;
  name: string;
  created_by?: IUser;
  created_by_fk: number;
  changed_on_utc?: string;
  changed_by_name?: string;
  options?: string;
  options_json?: {
    merge_pdf_config: MergeConfig,
    merge_csv_config: MergeCSVConfig,
    mail_merge: string;
    try_re_run?: boolean;
    condition_check?: string;
    condition_check_type?: string;
    destinations: string[];
    cover_image?: any;
  }
  blocks?: any[]; // report content
  ordered_blocks?: any[];
  webhook?: IWebhook | null;
  workflow?: IWorkflow | null;
  tags?: ITag[] | null;
  folder?: Folder | null;
  folder_id?: number;
  latest_executions?: any; /* TODO - load this separately and join it on the FE */
  selected?: boolean; // for the list view, for selecting multiple reports for bulk actions
}
